import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 20V18.8C16 17.1198 16 16.2798 15.673 15.638C15.3854 15.0735 14.9265 14.6146 14.362 14.327C13.7202 14 12.8802 14 11.2 14H6.8C5.11984 14 4.27976 14 3.63803 14.327C3.07354 14.6146 2.6146 15.0735 2.32698 15.638C2 16.2798 2 17.1198 2 18.8V20M16 5L18 7L22 3M12.5 6.5C12.5 8.433 10.933 10 9 10C7.067 10 5.5 8.433 5.5 6.5C5.5 4.567 7.067 3 9 3C10.933 3 12.5 4.567 12.5 6.5Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUserTick;
